<template>
  <div class="metadata-display px-2 d-flex flex-grow-1 flex-wrap">
    <div class="metadata-summary d-flex my-3 mx-auto flex-column">
      <div class="mt-4 d-flex flex-column">
        <div class="d-flex align-items-center mb-3">
          <h6 class="mb-0">All document fonts</h6>
          <a
            class="ml-2 d-flex align-items-center mb-0"
            href="https://help.inscribe.ai/en/articles/4582774-document-fonts"
            target="_blank"
          >
            <icon-hover symbol="small-question-mark" :size="16"></icon-hover>
          </a>
        </div>
        <div class="mt-2">
          <b-table
            :fields="fontsMetadataTableKeys"
            :responsive="true"
            :busy="documentFontsMetadata.isLoading"
            :items="documentFontsMetadata.fonts"
            :show-empty="true"
            data-testid="fonts-table"
            class="ui-table metadata-table card"
          >
            <template #empty>
              <h6>No fonts were found in this document</h6>
            </template>
            <template #table-busy>
              <i-spinner></i-spinner>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { iSpinner } from '@inscribe/signal';
import IconHover from '@/V2/components/IconHover';

export default {
  components: { IconHover, iSpinner },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fontsMetadataTableKeys: {
        name: { key: 'name', label: 'Name', tdClass: 'fs-exclude' },
      },
    };
  },
  computed: {
    documentFontsMetadata() {
      return this.$store.state.documentFontsMetadata;
    },
  },
  mounted() {
    this.getDocumentFontsMetadata();
  },
  methods: {
    getDocumentFontsMetadata() {
      this.$store.commit('setFontsMetadataLoading', true);
      this.$store
        .dispatch('getFontsMetadata', {
          customerId: this.document.customer_id,
          documentId: this.document.id,
        })
        .then(() => {
          this.$store.commit('setFontsMetadataLoading', false);
        });
    },
  },
};
</script>

<style lang="scss">
.metadata-display {
  max-height: 100%;
  overflow: auto;

  .metadata-summary {
    max-width: 600px;
    width: 100%;

    .card {
      overflow-x: auto;
    }
  }

  .metadata-table {
    font-size: $font-size-secondary;

    .metadata-value {
      max-width: 375px;
    }
  }
}
</style>
